import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, } from '@angular/common/http';
import { AppConfig } from '../../app-config';

// models
import { SchoolData } from 'src/app/models/schoolUser';
import { Action } from 'rxjs/internal/scheduler/Action';

@Injectable({
    providedIn: 'root'
})
export class TeacherJobsService {

    public schoolProps!: SchoolData;

    constructor(
        private httpClient: HttpClient,
        private apiUrl: AppConfig
    ) { }


    // public teacherJobsAPI = (params: any): Observable<any> => {
    //     // Check for authentication token (example: from localStorage)
    //     const getCookie = (name: string) => {
    //         const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    //         return match ? match[2] : null;
    //     };
    //     const accessToken = getCookie('access_token');
    //     const refreshToken = getCookie('refresh_token');
    //     let headers = {};
    //     if (accessToken) {
    //         headers = { Authorization: `Bearer ${accessToken}` };
    //         return this.httpClient.get<any>(
    //             this.apiUrl.teacherApiURL.teacherJobsAPI,
    //             { params, headers }
    //         );
    //     } else {
    //         return this.httpClient.get<any>(
    //             this.apiUrl.teacherApiURL.publicJobAPI,
    //             { params }
    //         );
    //     }

    // }
    public teacherJobsAPI = (payload: any): Observable<any> => {
        return this.httpClient.get<any>(this.apiUrl.teacherApiURL.teacherJobsAPI, { params: payload });
    }
    public sideComponentAPI = (): Observable<any> => {
        return this.httpClient.get<any>(this.apiUrl.teacherApiURL.sideComponentAPI);
    }
    public applyJobAPI = (payload: any): Observable<any> => {
        return this.httpClient.post<any>(this.apiUrl.teacherApiURL.applyJobAPI, payload);
    }
    updateApplicantDocumentAPI = (payload: any): Observable<any> => {
        return this.httpClient.post<any>(this.apiUrl.teacherApiURL.updateApplicantDocumentAPI, payload);
    }

    public quickApplyJobAPI = (payload: any): Observable<any> => {
        return this.httpClient.post<any>(this.apiUrl.teacherApiURL.quickApplyJobAPI, payload);
    }

    public savedJobs = (params: any = {}): Observable<any> => {
        return this.httpClient.get<any>(this.apiUrl.teacherApiURL.savedJobs, { params });
    }

    public appliedJobs = (params: any = {}): Observable<any> => {
        return this.httpClient.get<any>(this.apiUrl.teacherApiURL.appliedJobs, { params });
    }



    public teacherJobDetailsAPI = (job_id: string): Observable<any> => {
        return this.httpClient.get<any>(this.apiUrl.teacherApiURL.teacherJobDetailsAPI + job_id, { params: { job_id: job_id } });
    }

    public jobSaveUnsaveAPI = (jobId: any, action: string): Observable<any> => {
        return this.httpClient.post<any>(this.apiUrl.teacherApiURL.jobSaveUnsaveAPI, { job_id: jobId, type: action });
    }
    public pendingHistoryAPI = (filterData: any): Observable<any> => {
        return this.httpClient.get<any>(this.apiUrl.teacherApiURL.pendingHistoryAPI, { params: filterData });
    }
    public requestAction = (requestData: any): Observable<any> => {
        return this.httpClient.post<any>(this.apiUrl.teacherApiURL.requestActionAPI, requestData);
    }
    public teacherChoicesAPI = (requestData: any): Observable<any> => {
        return this.httpClient.get<any>(this.apiUrl.teacherApiURL.teacherChoicesAPI, { params: requestData });
    }
    sendInviteAPI = (requestData: any): Observable<any> => {
        return this.httpClient.post<any>(this.apiUrl.teacherApiURL.sendInviteAPI, requestData);
    }
    cancelInviteAPI = (requestData: any): Observable<any> => {
        return this.httpClient.post<any>(this.apiUrl.teacherApiURL.cancelInviteAPI, requestData);
    }

}
